import { useQuery } from '@apollo/client';
import { GET_ARTICULO_ID } from '../actions/articulo';
import { GET_COMENTARIO_ID } from '../actions/comentario';
import { GET_CUENTO_ID } from '../actions/cuento';
import { GET_POESIA_ID } from '../actions/poesia';
import { GET_PONENCIA_ID } from '../actions/ponencia';
import { GET_SERVICIO_ID } from '../actions/servicio';
import { GET_ENSENANZA_ID } from '../actions/ensenanza';
import { GET_LIBRO_ID } from '../actions/libro';

export const useSelectedArticuloId = () => {
  const { data: getArticuloId } = useQuery(GET_ARTICULO_ID);

  return getArticuloId?.getArticuloId;
};

export const useSelectedComentarioId = () => {
  const { data: getComentarioId } = useQuery(GET_COMENTARIO_ID);

  return getComentarioId?.getComentarioId;
};

export const useSelectedCuentoId = () => {
  const { data: getCuentoId } = useQuery(GET_CUENTO_ID);

  return getCuentoId?.getCuentoId;
};

export const useSelectedPoesiaId = () => {
  const { data: getPoesiaId } = useQuery(GET_POESIA_ID);

  return getPoesiaId?.getPoesiaId;
};

export const useSelectedPonenciaId = () => {
  const { data: getPonenciaId } = useQuery(GET_PONENCIA_ID);

  return getPonenciaId?.getPonenciaId;
};

export const useSelectedServicioId = () => {
  const { data: getServicioId } = useQuery(GET_SERVICIO_ID);

  return getServicioId?.getServicioId;
};

export const useSelectedEnsenanzaId = () => {
  const { data: getEnsenanzaId } = useQuery(GET_ENSENANZA_ID);

  return getEnsenanzaId?.getEnsenanzaId;
};

export const useSelectedLibroId = () => {
  const { data: getLibroId } = useQuery(GET_LIBRO_ID);

  return getLibroId?.getLibroId;
};
